import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Subscription } from 'rxjs';

export const MY_CUSTOM_FORMATS = {
  datePickerInput: 'DD MMMM YYYY',
  monthYearLabel: 'MMM YYYY'
};
@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss']
})
export class DateInputComponent {
  dateNgModel: any;
  dateRangeNgModel: any;
  dateFormControl = new FormControl();
  dateRangeFormControl = new FormControl();
  form!: FormGroup;
  dateDisabled: any;
  dateRangeDisabled: any;
  dateInvalid = new Date('03 October 2022');
  dateMinMax: any;
  dateRangeValue: any;
  minDate = new Date('03 October 2022');
  maxDate = new Date('25 October 2022');
  submitted = false;
  placeholder = 'Choose a date';
  placeholderValue = 'Selected date';
  fullDatePlaceholder: string = '';
  placeholderDateRange: string = 'Start Date - End Date';
  currentDate = new Date();
  newMinDate =  new Date(this.currentDate.getFullYear() - 2, this.currentDate.getMonth() - 6, this.currentDate.getDate());
  newMaxDate =  new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate());
  ariaLabel: string;
  ariaLabelMobile: string;
  fifteenDaysAgo = new Date('25 January 2025');
  isBrowser: boolean = true;
  paramsSubscription!: Subscription;
  selectedValue: any;
  selectedFrom: any;
  selectedTo: any;
  deviceAriaLabel: Record<string, string> = {
    mac: 'press option + down arrow for open date picker',
    android: 'Use touch and drag to open date picker',
    ios: 'Use touch and drag to open date picker',
    others: 'press alt + down arrow for open date picker'
  };
  smartInsightRange: any;
  defaultRange: number = 30;
  quickRanges: { label: string; days: number }[] = [
    { label: 'Last 1 Week', days: 7 },
    { label: 'Last 2 Weeks', days: 14 },
    { label: 'Last 1 Month', days: 30 },
    { label: 'Last 3 Months', days: 90 },
    { label: 'Last 6 Months', days: 180 },
    { label: 'Last 1 Year', days: 365 },
    { label: 'All Time', days: 913 }
  ];
  constructor(
    @Inject(PLATFORM_ID) public platformId: any,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
  ) { 
    this.isBrowser = isPlatformBrowser(this.platformId)
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      date: [null, Validators.required],
      dateRange: [null, Validators.required],
      dateForm:[null,Validators.required]
    });
    window['deviceAriaLabel'] = this.deviceAriaLabel;
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    const dates = new Date();
    this.fullDatePlaceholder = dates.getDate() + ' ' + monthNames[dates.getMonth()] + ' ' + dates.getFullYear();
    this.ariaLabel ="date selection keyboard 2";
    this.ariaLabelMobile="date selection mobile 2";
    this.paramsSubscription = this.route.queryParams.subscribe(param => {
      if(param['selectedDate']){
        this.selectedValue = param['selectedDate'];
      }else if(param['from']) {
        this.selectedFrom = param['from'];
        this.selectedTo = param['to'];
      }
    })
  }

  submit() {
    this.submitted = true;
  }
}